"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = webmidi;

function webmidi(access, logAccess = false) {
  let midi = access,
      allDevices = [];

  function getPort(type, portName, report = true) {
    const isBootloader = portName.toLowerCase().includes('bootloader');
    let devices = Array.from(midi[type].values()).filter(port => {
      if (isBootloader) {
        return port.name.includes(portName);
      } else {
        return port.name.includes(portName) && !portName.toLowerCase().includes('bootloader');
      } // return port.name === portName;

    });
    if (report && devices.length === 0) console.warn(`! >> webmidi: ${portName} ${type.replace('puts', 'put')} not found`);
    return devices[0];
  }

  return {
    getInput: (port, report) => getPort('inputs', port, report),
    getOutput: (port, report) => getPort('outputs', port, report)
  };
}